import { createSlice } from "@reduxjs/toolkit";

const diamondSieveSlice = createSlice({
    name:"diamondSieve",
    initialState:{
        diamondSieves:null
    },
    reducers:{
        setDiamondSieveList(state,action){
            state.diamondSieves = action?.payload;
        },
    }
})


export const {setDiamondSieveList} = diamondSieveSlice.actions
export default diamondSieveSlice.reducer